import { ApAccordionComponent, ApAccordionItemComponent } from '@ap/accordion';
import { ApButtonLinkComponent } from '@ap/button';
import { ApKeywordExplanationComponent } from '@ap/explanation/keyword';
import { ApGeldLenenKostGeldComponent } from '@ap/geld-lenen-kost-geld';
import { ApIconComponent } from '@ap/icon';
import { ApIconLinkComponent } from '@ap/icon-link';
import { ApNotificationComponent } from '@ap/notification';
import { ApAmountDisplayComponent } from '@ap/amounts';

import {
    ApIconListItemWrapperComponent,
    ApPanelWrapperComponent,
    ApCardWrapperComponent,
    ApImageCardWrapperComponent
} from './content-components.component';

export const ContentTypes = {
    amount: ApAmountDisplayComponent,
    keywordExplanation: ApKeywordExplanationComponent,
    explain: ApKeywordExplanationComponent,
    icon: ApIconComponent,
    notification: ApNotificationComponent,
    iconLink: ApIconLinkComponent,
    accordion: ApAccordionComponent,
    accordionItem: ApAccordionItemComponent,
    geldLenenKostGeld: ApGeldLenenKostGeldComponent,
    buttonLink: ApButtonLinkComponent,
    iconListItem: ApIconListItemWrapperComponent,
    panel: ApPanelWrapperComponent,
    card: ApCardWrapperComponent,
    imageCard: ApImageCardWrapperComponent
};
